import AttendStampForm from "./AttendStampAggregation";

export default AttendStampForm;
